<template>
    <div v-if="data" class="mr-3 uncomp-jobs">
        <v-tooltip text="Nuwall Stock" location="bottom">
            <template v-slot:activator="{ props }">
                <v-badge @click="show = true" :content="data.stock.length">
                    <v-icon icon="mdi-alpha-n-box" v-bind="props" class="text-yellow-lighten-3"></v-icon>
                </v-badge>
            </template>
        </v-tooltip>
        <v-dialog v-model="show"
                  persistent
                  fullscreen
                  transition="dialog-bottom-transition"
                  :scrim="false">
            <v-card>
                <v-toolbar dark
                           color="primary">
                    <v-toolbar-title>Nu-Wall Stock</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon
                           dark
                           @click="show = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="d-flex">
                    <v-row>
                        <v-col cols="4">
                            <nimp-stock></nimp-stock>
                        </v-col>
                        <v-col cols="4" class="border-e-sm">
                            <h3>Recent Stock Removals</h3>
                            <p>Below is all recent Nu-Wall picked stock transactions.</p>
                            <div class="h-100 overflow-y-auto">
                                <v-table>
                                    <tbody>
                                        <tr>
                                            <th>Date</th>
                                            <th>Item</th>
                                            <th>Quantity</th>
                                            <th>Job</th>
                                        </tr>
                                        <tr v-for="item in data.recent" :key="item.id">
                                            <td>{{ $dayjs(item.dateCreated).format('DD-MM-YYYY') }}</td>
                                            <td>{{ item.description }}</td>
                                            <td>{{ item.quantity }}</td>
                                            <td><job-link :job="item"></job-link></td>
                                        </tr>
                                    </tbody>
                                </v-table>
                            </div>
                        </v-col>
                        <v-col cols="4" class="border-e-sm">
                            <h3>Outstanding Stock → Strip</h3>
                            <p>Below is all outstanding Nu-Wall stock to be stripped. Tick the items you are planning to strip and convert to a job for processing.</p>
                            <div class="d-flex justify-space-between border-t-sm border-b-sm my-2 py-2">
                                <h3>{{ totalItemsToStrip }} <small class="text-muted">TOTAL ITEMS TO STRIP</small></h3>
                                <v-btn prepend-icon="mdi-archive-sync-outline"
                                       :disabled="totalItemsToStrip  == 0"
                                       :loading="saving"
                                       @click="convertToStrip">CONVERT ITEMS TO STRIP JOB</v-btn>
                            </div>
                            <v-table>
                                <tbody>
                                    <tr>
                                        <th>
                                            <v-checkbox-btn :model-value="allSelected"
                                                            :indeterminate="someSelected && !allSelected"
                                                            :disabled="data.stock.length == 0"
                                                            @update:model-value="toggleAll"
                                                            hide-details></v-checkbox-btn>
                                        </th>
                                        <th>Date</th>
                                        <th>Item</th>
                                        <th>Quantity</th>
                                        <th>Job</th>
                                    </tr>
                                    <tr v-for="(item, index) in data.stock" :key="itemKey(item, index)">
                                        <td>
                                            <v-checkbox-btn :model-value="isSelected(item, index)"
                                                            @update:model-value="toggleItem(item, index)"
                                                            hide-details></v-checkbox-btn>
                                        </td>
                                        <td>{{ $dayjs(item.dateCreated).format('DD-MM-YYYY') }}</td>
                                        <td>{{ item.description }}</td>
                                        <td>{{ item.quantity }}</td>
                                        <td><job-link :job="item"></job-link></td>
                                    </tr>
                                </tbody>
                            </v-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<style scoped>
    .uncomp-jobs {
        cursor:pointer;
    }
</style>
<script>
    import { numberWithCommas } from "../mixins/numberMixins";
    import { mapActions } from "vuex";
    function initialState() {
        return {
            saving: false,
            loading: false,
            show: false,
            data: null,
            selectedKeys: [],
            refreshInterval: null
        };
    }
    export default {
        name: "NuwallStock",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.loadData();
            this.refreshInterval = setInterval(() => {
                this.loadData();
            }, 600000);
        },
        beforeUnmount: function () {
            // Clean up the interval when component is destroyed
            if (this.refreshInterval) {
                clearInterval(this.refreshInterval);
            }
        },
        props: {
            props: Object,
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack"
            ]),
            numberWithCommas,
            reset: function () {
                Object.assign(this.$data, initialState());
            },
            itemKey(item, index) {
                // Composite key of the JobItemTask primary key; fall back to the row
                // index so rows stay independently keyed even if the ids are missing.
                if (item.jobItemId != null && item.jobTaskId != null) {
                    return `${item.jobItemId}-${item.jobTaskId}`;
                }
                return `row-${index}`;
            },
            isSelected(item, index) {
                return this.selectedKeys.includes(this.itemKey(item, index));
            },
            toggleItem(item, index) {
                const key = this.itemKey(item, index);
                const idx = this.selectedKeys.indexOf(key);
                if (idx === -1) {
                    this.selectedKeys.push(key);
                } else {
                    this.selectedKeys.splice(idx, 1);
                }
            },
            toggleAll(value) {
                this.selectedKeys = value ? this.data.stock.map((a, i) => this.itemKey(a, i)) : [];
            },
            loadData() {
                this.loading = true;
                this.$api.get('dashboard/nuwallstock')
                    .then(res => {
                        this.data = res.data;
                        // Drop any selections that are no longer outstanding
                        const validKeys = new Set(this.data.stock.map((a, i) => this.itemKey(a, i)));
                        this.selectedKeys = this.selectedKeys.filter(k => validKeys.has(k));
                        this.loading = false;
                    }).catch(error => {
                        this.loading = false;
                        this.showErrorSnack("Whoops. We ran into an error.");
                    });
            },
            convertToStrip() {
                const items = this.selectedStock.map(a => ({ jobItemId: a.jobItemId, jobTaskId: a.jobTaskId }));
                if (items.some(a => a.jobItemId == null || a.jobTaskId == null)) {
                    this.showErrorSnack("Stock rows are missing their identifiers. Please refresh and try again.");
                    return;
                }
                this.$confirm(
                    {
                        message: `This will convert ${items.length} selected stock item(s) to a stripping job. Are you sure?`,
                        disableKeys: false,
                        auth: false,
                        button: {
                            no: 'No',
                            yes: 'Yes'
                        },
                        callback: confirm => {
                            if (confirm) {
                                this.saving = true;
                                this.$api.post('dashboard/convertnuwallstripstock', { items })
                                    .then(res => {
                                        this.saving =  false;
                                        this.loadData();
                                        this.show = false;
                                        this.$router.push(`/jobs/${res.data.id}`);
                                    }).catch(error => {
                                        this.saving = false;
                                        this.showErrorSnack("Whoops. We ran into an error.");
                                    });
                            }
                        }
                    }
                )
            }
        },
        computed: {
            selectedStock() {
                if (!this.data) {
                    return [];
                }
                return this.data.stock.filter((a, i) => this.selectedKeys.includes(this.itemKey(a, i)));
            },
            allSelected() {
                return !!this.data && this.data.stock.length > 0 && this.selectedKeys.length === this.data.stock.length;
            },
            someSelected() {
                return this.selectedKeys.length > 0;
            },
            totalItemsToStrip() {
                return this.selectedStock.reduce((acc, obj) => acc + obj.quantity, 0);
            }
        }
    };
</script>
